import React from 'react'
import EnrollmentForm from '../../components/forms/enrollment_form'
import EnrollmentFormContent from './content/EnrollmentFormContent'


function Enrollment() {

  return (
    <div>
      <EnrollmentFormContent />
      <EnrollmentForm />
    </div>
  )
}

export default Enrollment